import { formatCurrencyValue } from "~/utils/functions/formatCurrencyValue";

// // // //

/**
 * TokenAggregatesBarChartTooltip
 * Matches the NetFlowsChart tooltip layout, minus its positive/negative
 * coloring - a bar's value has no directional meaning here.
 */
export function TokenAggregatesBarChartTooltip(props: {
    name: string;
    iconUrl: string;
    label: string;
    value: number;
    unitPrefix: string;
}) {
    const { name, iconUrl, label, value, unitPrefix } = props;

    return (
        <div className="flex flex-col select-none p-4 min-w-[28rem]">
            <div className="flex items-center gap-2 mb-3">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    src={iconUrl}
                    alt={name}
                    className="h-5 w-5 shrink-0 rounded-full"
                />
                <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground leading-tight mb-0.5">
                        {name}
                    </h3>
                </div>
            </div>

            <div className="flex items-center justify-between gap-6">
                <p className="text-base font-medium text-foreground">{label}</p>
                <span className="text-base font-bold tabular-nums text-foreground">
                    {unitPrefix}
                    {formatCurrencyValue(value)}
                </span>
            </div>
        </div>
    );
}
